<ion-app>
  @if (isUpdateRequired() === undefined) {
    <p class="ion-text-center">{{ 'general.check_version' | translate }}</p>
  } @else {
    <ion-split-pane
      when="md"
      contentId="main"
    >
      @if (isAuthenticateUser() && !isUpdateRequired()) {
        <ion-menu
          contentId="main"
          [side]="menuPosition()"
        >
          <app-menu-header></app-menu-header>

          <ion-content>
            <app-menu-main></app-menu-main>
          </ion-content>

          <ion-footer>
            <app-menu-footer></app-menu-footer>
          </ion-footer>
        </ion-menu>
      }
      <ion-router-outlet id="main"></ion-router-outlet>
    </ion-split-pane>
  }
</ion-app>
